import OutgoingBox from './OutgoingBox'

export default OutgoingBox
